export const FILE_TYPE_BADGES: Record<string, { label: string; className: string; color: string }> = {
  pdf: { label: 'PDF', className: 'bg-red-100', color: '#e40741' },
  doc: { label: 'DOC', className: 'bg-light-blue', color: '#0094cc' },
  docx: { label: 'DOC', className: 'bg-light-blue', color: '#0094cc' },
  xls: { label: 'XLS', className: 'bg-green', color: '#08aa7b' },
  xlsx: { label: 'XLS', className: 'bg-green', color: '#08aa7b' },
  csv: { label: 'CSV', className: 'bg-green', color: '#08aa7b' },
  ppt: { label: 'PPT', className: 'bg-yellow', color: '#f2a805' },
  pptx: { label: 'PPT', className: 'bg-yellow', color: '#f2a805' },
};

const CONTENT_TYPE_EXTENSIONS: Record<string, string> = {
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'text/csv': 'csv',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
};

const GENERIC_CONTENT_TYPE_SUBTYPES = new Set(['octet-stream', 'binary', 'download', 'x-download']);

export const extensionFromContentType = (contentType = '') => {
  const mimeType = contentType.split(';')[0]?.trim().toLowerCase();
  if (!mimeType) return '';
  if (CONTENT_TYPE_EXTENSIONS[mimeType]) return CONTENT_TYPE_EXTENSIONS[mimeType];
  const subtype = mimeType.split('/').pop() ?? '';
  return GENERIC_CONTENT_TYPE_SUBTYPES.has(subtype) ? '' : subtype;
};

export const getFileBadge = ({ contentType = '' }: { contentType?: string; fileName?: string }) => {
  const ext = extensionFromContentType(contentType);
  return (
    FILE_TYPE_BADGES[ext] ?? {
      label: ext ? ext.slice(0, 3).toUpperCase() : 'FILE',
      className: 'bg-main-blue',
      color: '#00122b',
    }
  );
};
